import { useAppDispatch, useAppSelector } from "app/hooks";
import { Column } from "components/Table/OLTable";
import { useCallback } from "react";
import { selectTableListings, setTables } from "reduxState/tables/tablesSlice";
import { SelectedFilter } from "types/filters";
import { Order } from "types/listing";

export interface LocalStorageTablesShape {
  [key: string]: {
    filters?: SelectedFilter[];
    listing?: {
      order: Order;
      property: string;
      rowsPerPage: number;
      page: number;
    };
    column_ordering?: { property: string; isVisible: boolean }[];
  };
}

export function useTablesStateHelpers(tableName?: string) {
  const dispatch = useAppDispatch();
  const listing = useAppSelector((state) =>
    selectTableListings(state, tableName || ""),
  );

  const setPersistentFilters = useCallback(
    (filters: SelectedFilter[], tableName: string) => {
      dispatch(
        setTables({
          [tableName]: {
            filters: filters,
          },
        }),
      );
    },
    [dispatch],
  );

  const setPersistentListingSorting = useCallback(
    (
      myOrder: any,
      myProperty: any,
      rowsPerPage: number,
      page: number,
      tableName: string,
    ) => {
      dispatch(
        setTables({
          [tableName]: {
            listing: {
              order: myOrder || "desc",
              property: myProperty,
              rowsPerPage: rowsPerPage || 10,
              page: page,
            },
          },
        }),
      );
    },
    [dispatch],
  );

  const setColumnOrdering = useCallback(
    (columns: Column[], tableName: string) => {
      dispatch(
        setTables({
          [tableName]: {
            column_ordering: columns.map((column) => ({
              property: column.property,
              isVisible: !!column.isVisible,
              isSticky: column.isSticky,
            })),
          },
        }),
      );
    },
    [dispatch],
  );

  return {
    setPersistentFilters,
    setPersistentListingSorting,
    setColumnOrdering,
    listing,
  } as const;
}

export const filterTable = (tables: LocalStorageTablesShape) => {
  const tablesOrdering: any = {};

  for (const key in tables) {
    tablesOrdering[key] = {
      ...(tables[key].column_ordering && {
        column_ordering: tables[key].column_ordering,
      }),
      ...(tables[key].listing?.rowsPerPage && {
        listing: { rowsPerPage: tables[key].listing?.rowsPerPage },
      }),
    };
  }

  return tablesOrdering;
};
